module.exports = __webpack_public_path__ + "static/domino-calculator-thumbnail.0a1eef02.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/domino-calculator-thumbnail.png
// module id = 458
// module chunks = 35783957827783